import { COMPANY, resolveLetterhead } from '../data/company'
import type { SablonSurum } from '../types'

export function DocLetterhead({ surum }: { surum: SablonSurum }) {
  const head = resolveLetterhead(surum)

  return (
    <header className="mb-6">
      <div className="flex min-w-0 items-center gap-3 pb-3">
        <img src={COMPANY.logo} alt={head.companyName} className="size-12 shrink-0 object-contain" />
        <div className="min-w-0 leading-tight">
          <div className="truncate text-[17px] font-bold tracking-tight text-brand-navy dark:text-foreground">
            {head.companyName.toLocaleUpperCase('tr')}
          </div>
          <div className="mt-0.5 truncate text-[10px] font-medium text-muted-foreground">{head.legalName}</div>
          <div className="mt-0.5 truncate text-[10px] font-semibold uppercase tracking-wider text-primary">{head.department}</div>
        </div>
      </div>
      <div aria-hidden className="flex h-[3px] gap-1">
        <span className="flex-1 rounded-full bg-primary" />
        <span className="w-14 rounded-full bg-brand-orange" />
      </div>
    </header>
  )
}
